const SMART_QUOTES: [RegExp, string][] = [
  [/\u201C/g, '"'],
  [/\u201D/g, '"'],
  [/\u2018/g, "'"],
  [/\u2019/g, "'"],
];

const DASHES: [RegExp, string][] = [
  [/\u2014/g, '--'],
  [/\u2013/g, '-'],
];

const BULLET_PREFIX = /^[\s]*(?:[-*\u2022]|\d+\.)\s+/;

/**
 * Normalises free-text FAQ answers so they are safe for JSON-LD
 * structured data. Pure function — no DOM dependency.
 *
 * Handles: smart/curly quotes, em/en dashes, literal newlines,
 * bullet / numbered-list prefixes, and excess whitespace.
 */
export function sanitizeFaqText(raw: string): string {
  if (!raw) return '';

  let text = raw;

  for (const [pattern, replacement] of SMART_QUOTES) {
    text = text.replace(pattern, replacement);
  }

  for (const [pattern, replacement] of DASHES) {
    text = text.replace(pattern, replacement);
  }

  // Split on line breaks, strip list-item prefixes, and rejoin as prose.
  const lines = text.split(/\r?\n|\r/);

  const cleaned = lines.reduce<string[]>((acc, line) => {
    const trimmed = line.replace(BULLET_PREFIX, '').trim();
    if (trimmed.length > 0) {
      acc.push(trimmed);
    }
    return acc;
  }, []);

  return cleaned.join(' ').replace(/\s{2,}/g, ' ').trim();
}
